<div *ngIf="!authInitialized" class="spinner-container">
    <div class="oval-container">
      <div class="oval-one"></div>
      <div class="oval-two"></div>
      <div class="oval-three"></div>
    </div>
    <div class="spinner-text-container">
      <span class="spinner-text">
       Operation Twin is currently loading, please do not take any action or you will leave the platform
      </span>
    </div>
  </div>
  
<router-outlet *ngIf="authInitialized"></router-outlet>
